<template>
    <div class="country" @click="itemClick()">
        <img :src="countryItemInfo.picture" alt="">
        <div class="countryName">{{countryItemInfo.countryName}}</div>
    </div>
</template>

<script>
    export default {
        props:{
            countryItemInfo:{
                type:Object,
                default(){
                    return {}
                }
            }
        },
        methods:{
            itemClick(){
                this.goPage('/schoolList')
                sessionStorage.setItem('countryId',this.countryItemInfo.id)
                sessionStorage.setItem('countryName',this.countryItemInfo.countryName)
            },
            goPage(url){
                this.$router.push(url)
            }
        },
    }
</script>
<style scoped>
    .country{
        width:20%;
        text-align: center;
        padding: 25px 0;
        line-height: 26px;
        float: left;
        cursor: pointer;
    }
    .countryName{
        margin-top:10px;
    }
    .country img{
        height:60px;
        width:60px;
        border-radius: 50%;
        margin:0 auto;
    }
@media screen and (max-width: 768px){
    .country{
        width:25%;
        padding: 0.2rem 0;
        line-height: 0.7rem;
    }
    .countryName{
        margin-top:0.2rem;
    }
    .country img{
        height:1rem;
        width:1rem;
    }
}
</style>